import { render, staticRenderFns } from "./CounterHomeTwo.vue?vue&type=template&id=c851db72&"
import script from "./CounterHomeTwo.vue?vue&type=script&lang=js&"
export * from "./CounterHomeTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports